import TyreCloseup from './Tyre_Closeup.jpg';
import Mileage from './mileage.jpg';
import TyreTread from './Tyre_Tread.png';
import Registration from './Registration.png';

const Images = {
    TyreCloseup,
    Mileage,
    TyreTread,
    Registration
};

export default Images;
